export default __webpack_public_path__ + "static/hw_ff_adc-bead40d007b419a26bbdd8b6e1f624ee.png";